import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteIcon from '@mui/icons-material/Delete';

export default function PortfolioTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650, }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Coin</TableCell>
            <TableCell align="right">Buy Price</TableCell>
            <TableCell align="right">Current Price</TableCell>
            <TableCell align="right">Buy Time</TableCell>
            <TableCell align="right">Units</TableCell>
            <TableCell align="right">Total Invested</TableCell>
            <TableCell align="right">Current Value</TableCell>
            <TableCell align="right">Profit</TableCell>
            <TableCell align="right">Gains / Loss</TableCell>
            <TableCell align="right">Gains / Loss %</TableCell>
            <TableCell align="right"></TableCell>
            {/* <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.rows?.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row?.coin?.name}
              </TableCell>
              <TableCell align="right">{row.buyPrice}</TableCell>
              <TableCell align="right">{row.currentPrice}</TableCell>
              <TableCell align="right">{row.buyTime}</TableCell>
              <TableCell align="right">{row.units}</TableCell>
              <TableCell align="right">{row.totalValue}</TableCell>
              <TableCell align="right">{row.currentValue}</TableCell>
              <TableCell align="right">{row.isProfit ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</TableCell>
              <TableCell align="right">{row.diff}</TableCell>
              <TableCell align="right">{row.perCent}</TableCell>
              <TableCell align="right"><DeleteIcon style={{cursor: 'pointer'}} onClick={() => props.onDeleteTrade(row.tradeID)}/></TableCell>
              {/* <TableCell align="right">{row.protein}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
